import React, { useEffect } from "react";

import getContentById from "../../../../shared/utils/getContentById";
import _ from "lodash";
import Backgrounds from "../../_partials/Backgrounds/Index";
import TemplateBlock from "../../_partials/TemplateBlock/Index";
import prepareVideoBg from "../../../../shared/functions/prepareVideoBg";
import animationScript, {
  animationCleanUp,
} from "./animations";

import assets from "./assets";
import getOptaCountryCode from "../../../../shared/utils/getOptaCountryCode";
import { useTranslation } from "react-i18next";
// import outroVideo9x16 from "../../../assets/outros/outro_playoffs_9x16.webm";
import Image from "../../../../shared/components/Image";
import { getPlayerShorLastName, getShortPlayerName } from "../../../../shared/feeds/worldcup/playerHelper";
import { WcBgCircle } from "../../../../shared/backgrounds/WcBgCircle/Index";
import ProgressBar from "../../../../shared/components/ProgressBar";
import { MatchScoreWidget } from "../../_partials/MatchScoreWidget/MatchScoreWidgetForBild";
import BildTeamLogo from "../../../../shared/components/Image/BildTeamLogo";

require("./style/style.scss");
require("./style/animation.scss");

const Index = (props) => {
  const refs = {
    player: React.createRef(),
    team: React.createRef(),
  };

  const {
    animation,
    data,
    images: Images,
    apiSetup,
    mode,
    format,
    isTimeline,
  } = props;

  const id = `${_.get(data, "template_name", "")}_${_.get(data, "uuid", "")}`;
  const { t } = useTranslation();

  const prepareAnimation = () => {
    prepareVideoBg({ id });
  };

  useEffect(() => {
    let animationReturn = null;
    if (mode === "animation" || mode === "video") {
      if (animation) {
        prepareAnimation();
        animationReturn = animationScript({
          refs,
          data,
          animation,
          mode,
          id,
          format,
          apiSetup,
          templateName: data?.template_name
        });
      }
    }

    //handle outro video BEGIN
    // if(mode === "video" && !isTimeline) {
    //   const outroVideo = $(`#${id} video.outro-optional-video`);
    //   outroVideo.get(0).addEventListener("loadedmetadata", function() {
    //       const that = this;
    //       setTimeout(()=> {
    //         outroVideo?.css('opacity', 1);
    //         this.currentTime = 0;
    //         that.play();
    //       }, frontendCfg.showOutroAfter)
    //     }, false);
    // }
    //handle outro video END

    return function cleanUp() {
      if (animationReturn) {
        animationCleanUp(animationReturn);
      }
    };
  }, [animation, mode]);

  const templateData = _.get(data, "data");

  const { options, fields, dynamic } = templateData;
  const matchInfo = _.get(dynamic, "matchInfo");
  const topPlayers = _.get(dynamic, "topPlayers");
  const homeTeam = matchInfo?.home;
  const awayTeam = matchInfo?.away;

  const teamSide = getContentById("selectedSide", fields);
  const rankingType = getContentById("rankingType", fields);
  return (
    <div
      id={id}
      className={`T_${_.get(data, "template_name", "")} ${animation ? "animation" : ""} side-${_.get(dynamic, "teamSide")}`}
    >
      <TemplateBlock class={`${isTimeline ? "" : "template-bild"}`}>
        {
          !isTimeline && <div className="main-header-content">
            <div className="main-header">
              {t(rankingType, { keyPrefix: "templates.TopPerformers" })}
            </div>
            <MatchScoreWidget
              homeTeam={homeTeam}
              awayTeam={awayTeam}
              matchInfo={matchInfo}
            />
          </div>
        }
        {/* <WcBgCircle /> */}

        <div className={"wc-content  wc-content-v2"}>
          <ProgressBar height={"8px"} />

          <div className={"group-table"}>
            {topPlayers && topPlayers.length ? (
              <div className={"group-content"}>
                <div className={"table-head"}>
                  <div className={"col-points"}>
                    {t(rankingType + "Col", {
                      keyPrefix: "templates.TopPerformers",
                    })}
                  </div>
                  <div className={'col-points'}>
                    {t("AssistsCol", {
                      keyPrefix: "templates.TopPerformers",
                    })}
                  </div>
                  {/*<div className={'col-points'}>Scorepunkte</div>*/}
                </div>
                {topPlayers.map((entry, index) => {
                  return (
                    <div key={"table-" + index} className={"table-row"}>
                      <div className={"col-pos"}>{++index}.</div>
                      <div className={"col-logo"}>
                        <BildTeamLogo className="team-logo" id={entry?.team_id} />
                      </div>
                      <div className={"col-team"}>
                        {entry?.person?.surname}
                      </div>
                      <div className={"col-points"}>{entry.goals}</div>
                      <div className={'col-points'}>{entry.assists}</div>
                      {/*<div className={'col-points'}>{entry.value}</div>*/}
                    </div>
                  );
                })}
              </div>
            ) : null}
          </div>

        </div>
      </TemplateBlock>
    </div>
  );
};

const getMainBackground = (format, side) => {
  return _.get(assets, `background_1920`);
};

export default Index;
